/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ChangeNewsStatusCommand } from '../model/changeNewsStatusCommand';
import { CreateNewsCommandResult } from '../model/createNewsCommandResult';
import { DeleteNewsCommandResult } from '../model/deleteNewsCommandResult';
import { GetNewsCategoriesQuery } from '../model/getNewsCategoriesQuery';
import { GetNewsCategoriesQueryResult } from '../model/getNewsCategoriesQueryResult';
import { GetNewsFeedQueryResult } from '../model/getNewsFeedQueryResult';
import { GetNewsQueryResult } from '../model/getNewsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { NewsInteractionCommand } from '../model/newsInteractionCommand';
import { NewsSortSpecification } from '../model/newsSortSpecification';
import { NewsStatusType } from '../model/newsStatusType';
import { VideoFormat } from '../model/videoFormat';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class NewsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param request 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newsCategoriesGet(request?: GetNewsCategoriesQuery, observe?: 'body', reportProgress?: boolean): Observable<GetNewsCategoriesQueryResult>;
    public newsCategoriesGet(request?: GetNewsCategoriesQuery, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetNewsCategoriesQueryResult>>;
    public newsCategoriesGet(request?: GetNewsCategoriesQuery, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetNewsCategoriesQueryResult>>;
    public newsCategoriesGet(request?: GetNewsCategoriesQuery, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (request !== undefined && request !== null) {
            queryParameters = queryParameters.set('request', <any>request);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetNewsCategoriesQueryResult>('get',`${this.basePath}/News/Categories`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param filterStatus 
     * @param filterStartCreatedDateTimeUTC 
     * @param filterEndCreatedDateTimeUTC 
     * @param filterStartPublishedDateTimeUTC 
     * @param filterEndPublishedDateTimeUTC 
     * @param filterCategories 
     * @param filterAuthorName 
     * @param filterTitle 
     * @param sort 
     * @param pageNumber 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newsGet(filterStatus?: Array<NewsStatusType>, filterStartCreatedDateTimeUTC?: Date, filterEndCreatedDateTimeUTC?: Date, filterStartPublishedDateTimeUTC?: Date, filterEndPublishedDateTimeUTC?: Date, filterCategories?: Array<string>, filterAuthorName?: string, filterTitle?: string, sort?: Array<NewsSortSpecification>, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<GetNewsFeedQueryResult>;
    public newsGet(filterStatus?: Array<NewsStatusType>, filterStartCreatedDateTimeUTC?: Date, filterEndCreatedDateTimeUTC?: Date, filterStartPublishedDateTimeUTC?: Date, filterEndPublishedDateTimeUTC?: Date, filterCategories?: Array<string>, filterAuthorName?: string, filterTitle?: string, sort?: Array<NewsSortSpecification>, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetNewsFeedQueryResult>>;
    public newsGet(filterStatus?: Array<NewsStatusType>, filterStartCreatedDateTimeUTC?: Date, filterEndCreatedDateTimeUTC?: Date, filterStartPublishedDateTimeUTC?: Date, filterEndPublishedDateTimeUTC?: Date, filterCategories?: Array<string>, filterAuthorName?: string, filterTitle?: string, sort?: Array<NewsSortSpecification>, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetNewsFeedQueryResult>>;
    public newsGet(filterStatus?: Array<NewsStatusType>, filterStartCreatedDateTimeUTC?: Date, filterEndCreatedDateTimeUTC?: Date, filterStartPublishedDateTimeUTC?: Date, filterEndPublishedDateTimeUTC?: Date, filterCategories?: Array<string>, filterAuthorName?: string, filterTitle?: string, sort?: Array<NewsSortSpecification>, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {












        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterStatus) {
            filterStatus.forEach((element) => {
                queryParameters = queryParameters.append('Filter.Status', <any>element);
            })
        }
        if (filterStartCreatedDateTimeUTC !== undefined && filterStartCreatedDateTimeUTC !== null) {
            queryParameters = queryParameters.set('Filter.StartCreatedDateTimeUTC', <any>filterStartCreatedDateTimeUTC.toISOString());
        }
        if (filterEndCreatedDateTimeUTC !== undefined && filterEndCreatedDateTimeUTC !== null) {
            queryParameters = queryParameters.set('Filter.EndCreatedDateTimeUTC', <any>filterEndCreatedDateTimeUTC.toISOString());
        }
        if (filterStartPublishedDateTimeUTC !== undefined && filterStartPublishedDateTimeUTC !== null) {
            queryParameters = queryParameters.set('Filter.StartPublishedDateTimeUTC', <any>filterStartPublishedDateTimeUTC.toISOString());
        }
        if (filterEndPublishedDateTimeUTC !== undefined && filterEndPublishedDateTimeUTC !== null) {
            queryParameters = queryParameters.set('Filter.EndPublishedDateTimeUTC', <any>filterEndPublishedDateTimeUTC.toISOString());
        }
        if (filterCategories) {
            filterCategories.forEach((element) => {
                queryParameters = queryParameters.append('Filter.Categories', <any>element);
            })
        }
        if (filterAuthorName !== undefined && filterAuthorName !== null) {
            queryParameters = queryParameters.set('Filter.AuthorName', <any>filterAuthorName);
        }
        if (filterTitle !== undefined && filterTitle !== null) {
            queryParameters = queryParameters.set('Filter.Title', <any>filterTitle);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('Sort', <any>element);
            })
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetNewsFeedQueryResult>('get',`${this.basePath}/News`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param title 
     * @param description 
     * @param content 
     * @param categoryUids 
     * @param statusType 
     * @param file 
     * @param link 
     * @param publishedDateTimeUTC 
     * @param videoFormat 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newsPostForm(title?: string, description?: string, content?: string, categoryUids?: Array<string>, statusType?: NewsStatusType, file?: Blob, link?: string, publishedDateTimeUTC?: Date, videoFormat?: VideoFormat, observe?: 'body', reportProgress?: boolean): Observable<CreateNewsCommandResult>;
    public newsPostForm(title?: string, description?: string, content?: string, categoryUids?: Array<string>, statusType?: NewsStatusType, file?: Blob, link?: string, publishedDateTimeUTC?: Date, videoFormat?: VideoFormat, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateNewsCommandResult>>;
    public newsPostForm(title?: string, description?: string, content?: string, categoryUids?: Array<string>, statusType?: NewsStatusType, file?: Blob, link?: string, publishedDateTimeUTC?: Date, videoFormat?: VideoFormat, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateNewsCommandResult>>;
    public newsPostForm(title?: string, description?: string, content?: string, categoryUids?: Array<string>, statusType?: NewsStatusType, file?: Blob, link?: string, publishedDateTimeUTC?: Date, videoFormat?: VideoFormat, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (title !== undefined) {
            formParams = formParams.append('Title', <any>title) as any || formParams;
        }
        if (description !== undefined) {
            formParams = formParams.append('Description', <any>description) as any || formParams;
        }
        if (content !== undefined) {
            formParams = formParams.append('Content', <any>content) as any || formParams;
        }
        if (categoryUids) {
            categoryUids.forEach((element) => {
                formParams = formParams.append('CategoryUids', <any>element) as any || formParams;
            })
        }
        if (statusType !== undefined) {
            formParams = formParams.append('StatusType', <any>statusType) as any || formParams;
        }
        if (file !== undefined) {
            formParams = formParams.append('File', <any>file) as any || formParams;
        }
        if (link !== undefined) {
            formParams = formParams.append('Link', <any>link) as any || formParams;
        }
        if (publishedDateTimeUTC !== undefined) {
            formParams = formParams.append('PublishedDateTimeUTC', <any>publishedDateTimeUTC) as any || formParams;
        }
        if (videoFormat !== undefined) {
            formParams = formParams.append('VideoFormat', <any>videoFormat) as any || formParams;
        }

        return this.httpClient.request<CreateNewsCommandResult>('post',`${this.basePath}/News`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteNewsCommandResult>;
    public newsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteNewsCommandResult>>;
    public newsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteNewsCommandResult>>;
    public newsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling newsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteNewsCommandResult>('delete',`${this.basePath}/News/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newsUidGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetNewsQueryResult>;
    public newsUidGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetNewsQueryResult>>;
    public newsUidGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetNewsQueryResult>>;
    public newsUidGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling newsUidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetNewsQueryResult>('get',`${this.basePath}/News/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newsUidInteractionPost(uid: string, body?: NewsInteractionCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public newsUidInteractionPost(uid: string, body?: NewsInteractionCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public newsUidInteractionPost(uid: string, body?: NewsInteractionCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public newsUidInteractionPost(uid: string, body?: NewsInteractionCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling newsUidInteractionPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/News/${encodeURIComponent(String(uid))}/Interaction`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newsUidPatch(uid: string, body?: ChangeNewsStatusCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public newsUidPatch(uid: string, body?: ChangeNewsStatusCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public newsUidPatch(uid: string, body?: ChangeNewsStatusCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public newsUidPatch(uid: string, body?: ChangeNewsStatusCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling newsUidPatch.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('patch',`${this.basePath}/News/${encodeURIComponent(String(uid))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param title 
     * @param description 
     * @param content 
     * @param categoryUids 
     * @param statusType 
     * @param file 
     * @param link 
     * @param publishedDateTimeUTC 
     * @param videoFormat 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newsUidPutForm(uid: string, title?: string, description?: string, content?: string, categoryUids?: Array<string>, statusType?: NewsStatusType, file?: Blob, link?: string, publishedDateTimeUTC?: Date, videoFormat?: VideoFormat, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public newsUidPutForm(uid: string, title?: string, description?: string, content?: string, categoryUids?: Array<string>, statusType?: NewsStatusType, file?: Blob, link?: string, publishedDateTimeUTC?: Date, videoFormat?: VideoFormat, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public newsUidPutForm(uid: string, title?: string, description?: string, content?: string, categoryUids?: Array<string>, statusType?: NewsStatusType, file?: Blob, link?: string, publishedDateTimeUTC?: Date, videoFormat?: VideoFormat, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public newsUidPutForm(uid: string, title?: string, description?: string, content?: string, categoryUids?: Array<string>, statusType?: NewsStatusType, file?: Blob, link?: string, publishedDateTimeUTC?: Date, videoFormat?: VideoFormat, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling newsUidPut.');
        }










        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (title !== undefined) {
            formParams = formParams.append('Title', <any>title) as any || formParams;
        }
        if (description !== undefined) {
            formParams = formParams.append('Description', <any>description) as any || formParams;
        }
        if (content !== undefined) {
            formParams = formParams.append('Content', <any>content) as any || formParams;
        }
        if (categoryUids) {
            categoryUids.forEach((element) => {
                formParams = formParams.append('CategoryUids', <any>element) as any || formParams;
            })
        }
        if (statusType !== undefined) {
            formParams = formParams.append('StatusType', <any>statusType) as any || formParams;
        }
        if (file !== undefined) {
            formParams = formParams.append('File', <any>file) as any || formParams;
        }
        if (link !== undefined) {
            formParams = formParams.append('Link', <any>link) as any || formParams;
        }
        if (publishedDateTimeUTC !== undefined) {
            formParams = formParams.append('PublishedDateTimeUTC', <any>publishedDateTimeUTC) as any || formParams;
        }
        if (videoFormat !== undefined) {
            formParams = formParams.append('VideoFormat', <any>videoFormat) as any || formParams;
        }

        return this.httpClient.request<any>('put',`${this.basePath}/News/${encodeURIComponent(String(uid))}`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
